import { Component, Input, Output, EventEmitter, OnInit, AfterContentInit } from '@angular/core';

import { DropdownInterface } from '../../../core/models';

@Component({
  selector: 'app-schain-source-companies',
  standalone: false,
  templateUrl: './schain-source-companies.component.html',
  styleUrl: './schain-source-companies.component.scss'
})
export class SchainSourceCompaniesComponent implements OnInit, AfterContentInit {
  @Input() companies: DropdownInterface.ICompaniesDataGeneralSource[];

  @Input() public set allChecked(value: boolean | number) {
    if (typeof value === 'number') {
      this._allChecked = !!value;
    } else {
      this._allChecked = value;
    }
  }

  public get allChecked(): boolean {
    return this._allChecked;
  }

  @Input() public set isAllDisabled(value: boolean) {
    this._isAllDisabled = value;
  }

  public get isAllDisabled(): boolean {
    return this._isAllDisabled;
  }

  @Input() public set type(value: string) {
    this._type = value;
  }

  public get type(): string {
    return this._type;
  }

  @Input() public set listMaxHeight(value: number) {
    this._listMaxHeight = value + 'px';
  }

  public get listMaxHeight(): string {
    return this._listMaxHeight;
  }

  @Input() public set disabledItems(value: number[]) {
    this._disabledItems = value;
  }

  public get disabledItems(): number[] {
    return this._disabledItems;
  }

  @Output() changedItems = new EventEmitter<{ items: number[], isAll: boolean, hasChanges: boolean }>();
  initArray: DropdownInterface.ICompaniesDataGeneralSource[] = [];
  changedArray: DropdownInterface.ICompaniesDataGeneralSource[] = [];
  searchValue = '';
  listHeight = 'auto';
  companyChecked: number[] = [];
  outputData: { items: number[], isAll: boolean, hasChanges: boolean } = { items: [], isAll: false, hasChanges: false };
  companyState: { [key: number]: boolean } = {};

  private _isAllDisabled = false;
  private _type = 'filterList';
  private _allChecked = false;
  private _listMaxHeight = '800px';

  private _disabledItems: number[] = [];

  constructor() { }

  public ngOnInit(): void {
    this.initArray = JSON.parse(JSON.stringify(this.companies));
    this.changedArray = JSON.parse(JSON.stringify(this.companies));
  }

  public ngAfterContentInit(): void {
    this.listHeight = window.innerHeight - 280 + 'px';
    window.addEventListener('resize', () => {
      this.listHeight = window.innerHeight - 280 + 'px';
    });
  }


  protected updateAllChecked(): void {
    const checked = this.allChecked;
    this.companies.forEach(company => {
      if (this.disabledItems.includes(company.id)) {
        company.disabled = true;
        company.checked = false;
      } else {
        company.checked = checked;
        company.disabled = checked;
      }
    });

    this.companyChecked = this.companies.flatMap(company => {
      return company.checked ? [company.value] : [];
    });

    this.outputData = {
      isAll: this.allChecked,
      items: this.companyChecked,
      hasChanges: false,
    };

    this.changedItems.emit(this.outputData);
  }

  protected updateAllEndpointByCompanyChecked(_: boolean): void {
    this.companyChecked = this.companies.flatMap(company => {
      return company.checked ? [company.value] : [];
    });

    this.allChecked = this.isEveryElementChecked(this.companies);

    this.outputData = {
      isAll: this.allChecked,
      items: this.companyChecked,
      hasChanges: false,
    };

    this.changedItems.emit(this.outputData);
  }

  protected onSearchInput(event: Event): void {
    this.searchValue = (event.target as HTMLInputElement).value;
  }

  private isEveryElementChecked(array: DropdownInterface.ICompaniesDataGeneralSource[]): boolean {
    for (const element of array) {
      if (!element.checked) {
        return false;
      }
    }

    return true;
  }
}